import './util/vendor'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueStorage from 'vue-ls'
// 引用第三方组件: https://github.com/GitHub-Laziji/menujs
// 引用npm包会在electron打包的时候报错，故将源码下载到本地引用
import Contextmenu from './plugins/menujs'
// import Contextmenu from 'vue-contextmenujs'
import ElementUI from 'element-ui'
// import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
// import 'element-theme-dark'
// import VueI18n from 'vue-i18n'
import i18n from './i18n'

// http://static.kancloud.cn/wangjiachong/gongzuopian/1238637
// @xunlei/vue-context-menu
// import VueContextMenu from '@xunlei/vue-context-menu'
// Vue.use(VueContextMenu)

// 因为 Contextmenu 在 electron中无法正常使用，特引入此组件专门用于electron
// https://github.com/chiic/vue-contextmenu
// vue-contextmenu
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

// 问卷
// import '@/plugins/formgenerator/styles/index.scss'
// import '@/plugins/formgenerator/icons'
// 富文本
import Tinymce from './plugins/tinymce/index.vue'
Vue.component('tinymce', Tinymce)

// 来自 lumenIM: https://github.com/gzydong/LumenIM
import './core/global-component'
import './core/directives'
import '@/icons'
import '@/assets/css/global.less'

// lodash
import _ from 'lodash'

import './registerServiceWorker'
Vue.prototype._ = _
//
const constants = require('@/util/constants')

Vue.use(ElementUI)
// Vue.use(ElementUI, { locale })
Vue.use(Contextmenu)
// Vue.use(VueI18n)
Vue.use(mavonEditor)

// vue-ls options, 统一antv管理后台方式
let storageOptions = {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}
Vue.use(VueStorage, storageOptions)

Vue.config.productionTip = constants.IS_PRODUCTION

// const messages = {
//   zh: zh,
//   en: en
// }

// let local = Vue.ls.get(constants.I18N, constants.I18N_DEFAULT_LOCAL)
// i18n.locale = local

// en 的语言包中不存在 name , 我们默认cn，当en不存在时，使用cn的值
// const i18n = new VueI18n({
//   locale: local,
//   fallbackLocale: 'zh',
//   messages
// })

// new Vue({
//   el: '#app',
//   router,
//   store,
//   i18n,
//   components: { App },
//   template: '<App/>'
// })

// custom styles
// https://shouts.dev/articles/create-multiple-themes-in-vuejs
// import './assets/css/styles.scss'

new Vue({
  render: h => h(App),
  store,
  router,
  i18n,
  components: { App }
}).$mount('#app')
